import { createSvgIcon } from "@mui/material";

export const NewTab = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect width="20" height="20" fill="none" />
    <path
      d="M10 3H5C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H15C16.1046 17 17 16.1046 17 15V10M13.5 3H17V6.5"
      stroke="currentColor"
    />
    <path d="M17 3L10 10" stroke="currentColor" />
  </svg>,
  "NewTab",
);
